import React from 'react';
import $ from 'jquery';

import BaseClass from '@/pages/BaseClass';

import {accDiv, accMul, CommonValue, formatVideoTime, httpPost, pcUrl} from '@/utils/tools';
import Nav from '@/utils/nav';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'selectedIndex': 0,
            'list': [],
            'yanxueNum': 0,
            'tongyongNum': 0,
            'info': {
                'studyProcessList': []
            },
            'totalVideoTime': 0,
            'reportInfo': {},
            'reportUrl': "",
            'reportPreviewUrl': "",
            'studyStatusList': {
                0: '待学习',
                1: '学习中',
                2: '已学完',
            },
        };
    }

    componentDidMount() {
        this.getList();
    }

    getList() {
        let url = pcUrl('/study/course');
        httpPost(url, {}, 'GET')
            .then(data => {
                if (!data) data = [];

                //保存课题列表
                let courseIds = data.map(row => +row.courseId);
                CommonValue.set('course_ids', courseIds);

                this.setState({
                    'list': data,
                }, () => {
                    if (data.length) {
                        data.map((row, index) => {
                            if (row.courseType == '01') {
                                this.state.yanxueNum++;
                            } else if (row.courseType == '02') {
                                this.state.tongyongNum++;
                            }
                        });

                        this.navInit();
                        this.getInfo();
                    }
                });
            });
    }

    navInit() {
        $('.choosen-class').each(function () {
            let option = {
                'box': $(this).find('[rel="box"]').get(0),
                'width': 208 + 10,
                'show': 3,
                'direction': 'vertical',//'horizonal'
                'navBox': {
                    'left': $(this).find('.prev a').get(0),
                    'right': $(this).find('.next a').get(0),
                },
            };
            new Nav(option);
        });
    }

    getInfo() {
        this.state.totalVideoTime = 0;

        let courseType = this.state.list[this.state.selectedIndex].courseType;
        if (courseType == '01') {
            this.state.reportUrl = '/report1/';
            this.state.reportPreviewUrl = '/reportPreview1/';
        } else if (courseType == '02') {
            this.state.reportUrl = '/report2/';
            this.state.reportPreviewUrl = '/reportPreview2/';
        }

        let url = pcUrl('/study/course/' + this.state.list[this.state.selectedIndex].courseId);
        httpPost(url, {}, 'GET')
            .then(data => {
                let completeCount = 0;
                data.studyProcessList.forEach(row => {
                    let studyTime = row.studyTime || 0;
                    let videoTime = row.videoTime;
                    let studyProgress = Math.round(studyTime * 100 / videoTime);
                    console.log("studyProgress:"+studyProgress);
                    if (!studyProgress)
                        studyProgress = 0;
                    if (studyProgress > 100)
                        studyProgress = 100;

                    this.state.totalVideoTime += videoTime;
                    row.studyProgress = studyProgress;

                    if (row.status == 2)
                        completeCount++;
                });
                data.completeCount = completeCount;

                this.setState({
                    'info': data,
                });
            });

        this.getReportInfo();
    }

    getReportInfo() {
        let url = pcUrl('/study/course/' + this.state.list[this.state.selectedIndex].courseId + '/report');
        httpPost(url, {}, 'GET')
            .then(data => {
                if (data && data.id) {
                    this.setState({
                        'reportInfo': data,
                    });
                } else
                    this.setState({
                        'reportInfo': {},
                    });
            });
    }

    render() {
        return (
            <>
                <div className="index-panel choosen-class">
                    <div className="captain">
                        <h3>
                            <span className="clips index-panel-yxkt-ico"></span>
                            已选课题 <span
                            style={{'color': 'red'}}>(研学{this.state.yanxueNum}，通用{this.state.tongyongNum})</span>
                        </h3>
                    </div>
                    <div className="panel-body choosen-class-body">
                        {this.state.list.length > 0 ? (
                            <>
                                <div className="choosen-class-inner">
                                    <ul rel="box">
                                        {this.state.list.map((row, index) => (
                                            <li>
                                                <a href="javascript:;"
                                                   className={this.state.selectedIndex == index ? 'now' : ''}
                                                   onClick={() => this.setState({'selectedIndex': index}, () => this.getInfo())}>
                                                    <i className={'class-type-' + row.courseType}></i>
                                                    <img
                                                        src={"https://vod.jscqe.com/" + row.thumbUrl || require("@/assets/images/class_thumb.jpg")}/>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="navigator">
                                    <div className="prev">
                                        <a href="javascript:;" className="disabled">
                                            <span className="fa fa-angle-left"></span>
                                        </a>
                                    </div>
                                    <div className="next">
                                        <a href="javascript:;">
                                            <span className="fa fa-angle-right"></span>
                                        </a>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="padding-20 text-center text-gray">暂无数据</div>
                        )}
                    </div>

                    {this.state.info && this.state.info.id && (
                        <>
                            <div className="captain">
                                <h3>
                                    <span className="clips index-panel-xxrw-ico"></span>
                                    学习进度
                                    <span className="sub-captain">
										{this.state.info.courseName}
									</span>
                                </h3>
                            </div>
                            <div className="panel-body">
                                <div className="study-mission-inner">
                                    <dl onClick={() => window.open('/player/' + this.state.info.courseId, 'player')}>
                                        <dd className="float-left">
                                            <img src={require('@/assets/images/mission_01.png')}/>
                                        </dd>
                                        <dt>
                                            观看课程
                                        </dt>
                                        <dd className="text-gray">
                                            已完成
                                            {/*
											<span> {this.state.info.studyProgress * 100}% </span>
											*/}
                                            {this.state.info.completeCount} / {this.state.info.studyProcessList.length}
                                        </dd>
                                        <dd className="text-green">
                                            {this.state.studyStatusList[this.state.info.studyStatus]}
                                        </dd>
                                    </dl>
                                    <div>
                                        <img className="arrow-right-ico"
                                             src={require('@/assets/images/arrow_right.png')}/>
                                    </div>
                                    {this.state.reportInfo.id && this.state.reportInfo.status != 0 ? (
                                        <dl onClick={() => this.props.history.push(this.state.reportPreviewUrl + this.state.info.courseId)}>
                                            <dd className="float-left">
                                                <img src={require('@/assets/images/mission_02.png')}/>
                                            </dd>
                                            <dt>
                                                查看报告
                                            </dt>
                                            <dd className="dd-button">
                                                <a href="javascript:;" className="button button-blue">查看</a>
                                            </dd>
                                        </dl>
                                    ) : (
                                        <dl onClick={() => this.props.history.push((this.state.reportInfo.id && this.state.reportInfo.status == 0) ?
                                            (this.state.reportUrl + this.state.info.courseId + '?id=' + this.state.reportInfo.id) :
                                            (this.state.reportUrl + this.state.info.courseId))}>
                                            <dd className="float-left">
                                                <img src={require('@/assets/images/mission_02.png')}/>
                                            </dd>
                                            <dt>
                                                撰写报告
                                            </dt>
                                            <dd className="dd-button">
                                                <a href="javascript:;" className="button button-blue">写报告</a>
                                            </dd>
                                        </dl>
                                    )}
                                    <div>
                                        <img className="arrow-right-ico"
                                             src={require('@/assets/images/arrow_right.png')}/>
                                    </div>
                                    <dl onClick={() => window.open('/user/result', '_blank')}>
                                        <dd className="float-left">
                                            <img src={require('@/assets/images/mission_03.png')}/>
                                        </dd>
                                        <dt>
                                            下载成果
                                        </dt>
                                    </dl>
                                    <div className="clear"></div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <div className="height-15"></div>
                {this.state.info && this.state.info.id && (
                    <div className="index-panel choosen-class">
                        <div className="captain">
                            <h3>
                                <span className="clips index-panel-kcjd-ico"></span>
                                课程进度
                            </h3>
                        </div>
                        <div className="panel-body">
                            <table className="index-table">
                                <tr>
                                    <th width="40%">
                                        课节名称
                                    </th>
                                    <th width="20%" className="text-center">
                                        时长({formatVideoTime(this.state.totalVideoTime)})
                                    </th>
                                    <th width="20%" className="text-center">
                                        学习进度
                                    </th>
                                    <th width="20%" className="text-center">
                                        操作
                                    </th>
                                </tr>
                                {this.state.info.studyProcessList.map((row, index) => (
                                    <tr>
                                        <td> {row.nodeName} </td>
                                        <td className="text-center">
                                            <span className="text-green">{formatVideoTime(row.videoTime)}</span>
                                        </td>
                                        <td className="text-center">
                                            <span
                                                className="text-green">{(this.state.info.studyStatus == 2) ? this.state.studyStatusList[this.state.info.studyStatus] : (row.studyProgress + '%')}</span>
                                        </td>
                                        <td className="text-center">
                                            <a href="javascript:;" className="text-blue1"
                                               onClick={() => window.open('/player/' + row.courseId + '?id=' + row.nodeId, "player")}>
                                                <span className="clips play-ico"></span>
                                                &nbsp;
                                                去学习
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </div>
                    </div>
                )}
            </>
        );
    }
}


